import { Head } from '@inertiajs/react';
import { Schedule } from '@/components/schedule';
import { cn } from '@/lib/utils';
import type { HackerSchedulesShow } from '@/types';

// /:event_slug/hacker/schedule — hack-25's page (which 26-ar re-exports) and the 26-mx
// twin as one component (PORTING.md G5).
export default function Show({
  event,
  timeSlots,
  titleFont,
  subheader,
  timezoneOffset,
  timeZone,
}: HackerSchedulesShow) {
  return (
    <div className="min-h-screen bg-background">
      <Head title={`${event.name} - Cronograma`} />
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="mx-auto max-w-7xl space-y-6">
          <div className="text-center">
            <h1
              className={cn(
                'inline-block font-bold text-3xl text-primary sm:text-4xl md:text-5xl',
                titleFont,
              )}
            >
              <span className="bg-primary px-3 py-2 text-background">
                Cronograma
              </span>
            </h1>
            {subheader && (
              <p className="mt-4 font-mono text-primary/70 text-sm md:text-base">
                {subheader}
              </p>
            )}
          </div>

          {event.startsAt && event.endsAt && (
            <Schedule
              timeSlots={timeSlots}
              startsAt={event.startsAt}
              endsAt={event.endsAt}
              timezoneOffset={timezoneOffset}
              timeZone={timeZone}
              titleFont={titleFont}
            />
          )}
        </div>
      </div>
    </div>
  );
}
